import { createContext } from 'react';

import appTracking from '@glass/shared/modules/tracking/appTracking';

const TrackingContext = createContext(appTracking);

export default TrackingContext;
